/* eslint-disable react/prop-types */
import React, {PureComponent} from 'react';

import {FmlxToggleButton} from 'fmlx-common-ui';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import ExchangeCalculator from '@/assets/icons/ExchangeCalculator.svg';
import More from '@/assets/icons/More.svg';
import RedError from '@/assets/icons/RedError.svg';
import {applyDiafiltrationCalculator, changeBufferExchangeParam} from '@/businesses/autoProfileBufferExchangeBusiness';
import {
  changeConical,
  changeMethodAutoProfile,
  getDelayProfileState,
  handleWarningInvalidParamClick,
  initAutoProfileSetup,
  openAdvSetup,
  resetAutoProfileParams,
  resetMWCO,
  updateProfileParamByName,
} from '@/businesses/autoProfileBusiness';
import {changeConcentrate2TubesParam} from '@/businesses/autoProfileConc2TubesBusiness';
import {changeConcentrateParam} from '@/businesses/autoProfileConcBusiness';
import Button from '@/components/button/Button';
import IconExclamation from '@/components/icon/IconExclamation';
import InputField from '@/components/inputfield/InputField';
import MembraneType from '@/components/selectField/MembraneType';
import SelectField from '@/components/selectField/SelectField';
import SelectionDropdowns from '@/components/selectField/SelectionDropdowns';
import ToggleButton from '@/components/togglebutton/ToggleButton';
import {
  AutoProfileConstants,
  BufferExchangesStateMapper,
  Concentrate2TubesStateMapper,
  ConcentrateStateMapper,
  MembraneCutOff,
  MembraneTypeOptions,
} from '@/constants/autoProfileEnum';
import {
  AutoProfileSetupMode,
  AutoProfileSetupModes,
  ConicalOptionsV2,
  ConicalOptionsV3,
  ConicalType,
  MembraneCutOffOptions,
  MembraneCutOffRCOptions,
} from '@/constants/autoProfileOption';
import {VERSION_2} from '@/constants/constant';
import {RECOVERY_OF_LIQUID_ID, SKIP_PRIMING_ID} from '@/constants/enums';
import {LEFT_CONICAL} from '@/constants/fieldNames';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';
import * as PC_COMMON_FUNCTION from '@/libs/appHelper';
import {
  calcBufferNeededCalculator,
  calcMaxStepSizeCalculator,
  getLimitBufferVolToUseBufferExchange,
  getLimitFinalConcentrationBufferExchange,
  getLimitFinalConcentrationConc,
  getLimitFinalConcentrationConc2Tubes,
  getLimitFinalVolBufferExchange,
  getLimitFinalVolConc,
  getLimitFinalVolConc2Tubes,
  getLimitStartConcentration,
  getLimitStartingVol1stTubeConc2Tubes,
  getLimitStartingVol2ndTubeConc2Tubes,
  getLimitStartVol,
  getLimitStartVolConc,
  getLimitStepSizeBufferExchange,
  getLimitTotalBufferVolToUseBufferExchange,
  getLimitVolToStartAtBufferExchange,
  membraneTypeConverter,
} from '@/libs/autoProfileHelper';
import {objMapper} from '@/libs/objectHelper';

import AutoProfilePageMenu from '../reusable/AutoProfilePageMenu';
import AutoProfileTopMenu from '../reusable/AutoProfileTopMenu';

import './setup.less';
import '../reusable/AutoProfile.scss';

const INPUT = 'input';
const TOGGLE = 'toggle';
const SELECT = 'select';
const BUTTON = 'button';

@connect((store) => {
  const profileRunningConfig = store.setupStore.profileRunning?.Config;

  return {
    startingVolume: store.setupStore.currentProfileParams[APPDATA.KEY.StartingVolume],
    startingConcentration: store.setupStore.currentProfileParams[APPDATA.KEY.StartingConcentration],
    finalVolume: store.setupStore.currentProfileParams[APPDATA.KEY.FinalVolume],
    volumeToStartAt: store.setupStore.currentProfileParams[APPDATA.KEY.VolumeToStartAt],
    bufferVolumeToUse: store.setupStore.currentProfileParams[APPDATA.KEY.BufferVolumeToUse],
    exchangeStepSize: store.setupStore.currentProfileParams[APPDATA.KEY.ExchangeStepSize],
    stepSizeVolume: store.setupStore.currentProfileParams[APPDATA.KEY.StepSizeVolume],
    membraneCutOffSize: store.setupStore.currentProfileParams[APPDATA.KEY.MembraneCutOffSize],
    membraneType: store.setupStore.currentProfileParams[APPDATA.KEY.MembraneType],
    conicalVolume: store.setupStore.currentProfileParams[APPDATA.KEY.ConicalVolume],
    totalBufferVolumeToUse: store.setupStore.currentProfileParams[APPDATA.KEY.TotalBufferVolumeToUse],
    moreThan50ml: store.setupStore.currentProfileParams[APPDATA.KEY.MoreThan50ml],
    startingVolumeFor2ndTube: store.setupStore.currentProfileParams[APPDATA.KEY.StartingVolumeFor2ndTube],
    invalidAutoProfileParams: store.setupStore.invalidAutoProfileParams,
    currentProfileParams: store.setupStore.currentProfileParams,
    fontSize: store.setupStore.fontSize,
    isPCRunning: store.setupStore.isPCRunning,
    deviceVersion: store.setupStore.deviceVersion,
    autoProfileSetupMode: store.setupStore.autoProfileSetupMode,
    isScheduleWillRun: store.schedulerState.isScheduleWillRun,
    isSetScheduleRun: store.schedulerState.isSetScheduleRun,
    currentAdvSetupParamsName: store.setupStore.currentAdvSetupParams?.Name,
    profileRunningConfigStartingVolume: profileRunningConfig?.StartingVolume,
    profileRunningConfigStartingVolumeFor2ndTube: profileRunningConfig?.StartingVolumeFor2ndTube,
    profileRunningConfigStartingConcentration: profileRunningConfig?.StartingConcentration,
    profileRunningConfigFinalVolume: profileRunningConfig?.FinalVolume,
    profileRunningConfigEstimatedFinalConcentration: profileRunningConfig?.EstimatedFinalConcentration,
    profileRunningConfigVolumeToStartAt: profileRunningConfig?.VolumeToStartAt,
    profileRunningConfigBufferVolumeToUse: profileRunningConfig?.BufferVolumeToUse,
    profileRunningConfigExchangeStepSize: profileRunningConfig?.ExchangeStepSize,
    profileRunningConfigTotalBufferVolumeToUse: profileRunningConfig?.TotalBufferVolumeToUse,
    profileRunningConfigAdvancedSetupName: profileRunningConfig?.AdvancedSetupName,
    profileRunningConfigMoreThan50ml: profileRunningConfig?.MoreThan50ml,
    profileRunningConfigDiafiltrationMode: profileRunningConfig?.DiafiltrationMode,
    profileRunningConfigMembraneCutOffSize: profileRunningConfig?.MembraneCutOffSize,
    profileRunningConfigConicalVolume: profileRunningConfig?.ConicalVolume,
    advSetupSetupName: store.setupStore.currentProfileParams[APPDATA.KEY.AdvancedSetupName],
    highVolumeBufferFlag:
      store.setupStore.currentAdvSetupParams?.ConfigAdvSetup?.GeneralAdvSetup?.HighVolumeBufferFlag || false,
  };
})
class AutoProfileSetup extends PureComponent {
  static mapValue(currentProfileParams, configParam, autoProfileSetupMode) {
    const configParameter = configParam;
    switch (autoProfileSetupMode) {
      case AutoProfileSetupMode[0]:
        configParameter[autoProfileSetupMode] = objMapper(currentProfileParams, ConcentrateStateMapper);
        break;
      case AutoProfileSetupMode[1]:
        configParameter[autoProfileSetupMode] = objMapper(currentProfileParams, Concentrate2TubesStateMapper);

        break;
      case AutoProfileSetupMode[2]:
        configParameter[autoProfileSetupMode] = objMapper(currentProfileParams, BufferExchangesStateMapper);
        break;

      default:
        break;
    }
    return configParameter;
  }

  constructor(props) {
    super(props);
    this.state = {
      configParam: {
        [AutoProfileSetupMode[0]]: {
          startVolume: APPDATA.EMPTY_FIELD,
          finalVolume: APPDATA.EMPTY_FIELD,
          startConcentration: APPDATA.EMPTY_FIELD,
          finalConcentration: APPDATA.EMPTY_FIELD,
        },
        [AutoProfileSetupMode[1]]: {
          startVolume: 50,
          startVolume01: APPDATA.EMPTY_FIELD,
          startVolumeConical: 15,
          startVolume02: APPDATA.EMPTY_FIELD,
          finalVolume: APPDATA.EMPTY_FIELD,
          startConcentration: APPDATA.EMPTY_FIELD,
          finalConcentration: APPDATA.EMPTY_FIELD,
        },
        [AutoProfileSetupMode[2]]: {
          startVolume: APPDATA.EMPTY_FIELD,
          finalVolume: APPDATA.EMPTY_FIELD,
          startConcentration: APPDATA.EMPTY_FIELD,
          finalConcentration: APPDATA.EMPTY_FIELD,
        },
      },
      calculator: {
        volumeToStartAt: APPDATA.EMPTY_FIELD,
        percentage: APPDATA.EMPTY_FIELD,
        stepSize: 0.5,
        bufferNeeded: APPDATA.EMPTY_FIELD,
        exchangeStepSize: APPDATA.EMPTY_FIELD,
        stepSizeVolume: APPDATA.EMPTY_FIELD,
        showWarning: false,
      },
    };

    this.handleParametersChange = this.handleParametersChange.bind(this);
  }

  componentDidMount() {
    const {dispatch} = this.props;
    const {configParam} = this.state;

    dispatch(getDelayProfileState());
    const newConfigParam = dispatch(initAutoProfileSetup(configParam));

    this.setState({
      configParam: newConfigParam,
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const newConfigParam = AutoProfileSetup.mapValue(
      nextProps.currentProfileParams,
      prevState.configParam,
      nextProps.autoProfileSetupMode,
    );

    if (newConfigParam !== prevState.configParam) {
      return {configParam: newConfigParam};
    }
    // No state update necessary
    return null;
  }

  getDataSkipPriming(onClick) {
    const {skipPriming} = this.props;

    const skipPrimingToggle = [
      {
        label: APPDATA.FIELD_NAME.SKIP_PRIMING_OPTION.OFF,
        value: 1,
        onClick: this.handleParametersClick,
        customButtonSize: true,
      },
      {
        label: APPDATA.FIELD_NAME.SKIP_PRIMING_OPTION.ON,
        value: 2,
        onClick: this.handleParametersClick,
        customButtonSize: true,
      },
    ];
    const skipPrimingValue = SKIP_PRIMING_ID[skipPriming] ?? 0;

    return {
      label: APPDATA.FIELD_NAME.SKIP_PRIMING,
      buttonProp: skipPrimingToggle,
      defaultValue: skipPrimingValue,
      value: skipPrimingValue,
      onClick,
    };
  }

  showDiafiltrationCalculator = () => {
    const {dispatch} = this.props;
    const {calculator} = this.state;

    let isAllInputFilled = false;
    if (
      !PC_COMMON_FUNCTION.isEmptyFieldValue(calculator.volumeToStartAt) &&
      !PC_COMMON_FUNCTION.isEmptyFieldValue(calculator.percentage) &&
      !PC_COMMON_FUNCTION.isEmptyFieldValue(calculator.stepSize)
    )
      isAllInputFilled = true;

    const popUpButton = [
      {
        id: APPDATA.APPLY,
        isPrimaryButton: true,
        onClick: this.onClickCalculator,
        label: APPDATA.APPLY,
        disabled: !isAllInputFilled,
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickCalculator,
        label: APPDATA.CANCEL,
      },
    ];

    dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.BUFFER_EXCHANGE.CALCULATOR.TITLE,
        popUpText: (
          <div>
            <div className="rowHeightAutoProfile middleAlign ">
              <div className={APPSTYLE.COLUMN_9}>
                {this.renderInputField(
                  APPDATA.FIELD_NAME.VOLUME_TO_START_AT,
                  APPDATA.FIELD_NAME.VOLUME_TO_START_AT,
                  calculator.volumeToStartAt,
                  APPDATA.UNIT.ml,
                  this.onClickCalculator,
                  undefined,
                  false,
                )}
              </div>
            </div>
            <div className="rowHeightAutoProfile middleAlign ">
              <div className={APPSTYLE.COLUMN_9}>
                {this.renderInputField(
                  APPDATA.FIELD_NAME.EXCHANGE_PERCENTAGE,
                  APPDATA.FIELD_NAME.EXCHANGE_PERCENTAGE,
                  calculator.percentage,
                  '%',
                  this.onClickCalculator,
                  undefined,
                  false,
                )}
              </div>
              <div
                className={`${APPSTYLE.COLUMN_3}no-padding`}
                style={{textAlign: 'left'}}
              >
                {' '}
                of Solution B
              </div>
            </div>
            <div className="rowHeightAutoProfile middleAlign ">
              <div className={APPSTYLE.COLUMN_9}>
                {this.renderInputField(
                  APPDATA.FIELD_NAME.STEP_SIZE,
                  APPDATA.FIELD_NAME.STEP_SIZE,
                  calculator.stepSize,
                  APPDATA.UNIT.ml,
                  this.onClickCalculator,
                  undefined,
                  undefined,
                )}
              </div>
            </div>
            <div className="rowHeightAutoProfile middleAlign ">
              <div className={`${APPSTYLE.COLUMN_FULL}grayDiv`}>
                <div className="middleAlign">
                  <div className={APPSTYLE.COLUMN_6}>
                    <div className="row row-margin">
                      <span className="spanStyleInputField">{APPDATA.FIELD_NAME.EXCHANGE_VOLUME_NEEDED}</span>
                    </div>
                  </div>
                  <div className={APPSTYLE.COLUMN_2}>
                    {PC_COMMON_FUNCTION.isEmptyFieldValue(calculator.bufferNeeded) ? ' ' : calculator.bufferNeeded}
                  </div>
                  <div className={APPSTYLE.COLUMN_1}>
                    <span
                      className="spanStyleInputField unit"
                      style={{textAlign: 'left'}}
                    >
                      {APPDATA.UNIT.ml}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {calculator.showWarning && (
              <div className="row warning-div-calculator ">
                <img
                  className="icon"
                  id="iconWarningCalculator"
                  src={RedError}
                  alt={RedError}
                />
                <div className="warning-div-calculator-text">
                  {APPDATA.MESSAGES.BUFFER_EXCHANGE.CALCULATOR.WARNING.replace(
                    '{MIN}',
                    APPDATA.CONFIGURATION.VOLUME_SENSOR.MIN_VALUE,
                  ).replace('{MAX}', 300)}
                </div>
              </div>
            )}
          </div>
        ),
        popUpButton,
      }),
    );
  };

  getDataRecoveryOfLiquid = (label, onClick) => {
    const {recoveryOfLiquid, moreThan50ml} = this.props;
    const defaultRecoveryOfLiquid = RECOVERY_OF_LIQUID_ID[recoveryOfLiquid] ?? 0;

    const availableBuffer = moreThan50ml === APPDATA.ENUM.MORE_THAN_50_ML.OFF;
    const recoveryOfLiquidComplete = [
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.None,
        value: 1,
        onClick: this.handleParametersClick,
      },
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Air,
        value: 2,
        onClick: this.handleParametersClick,
      },
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Buffer,
        value: 3,
        onClick: this.handleParametersClick,
      },
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Air_Buffer.replace('_', ' & '),
        value: 4,
        onClick: this.handleParametersClick,
      },
    ];
    const recoveryOfLiquidWithoutBuffer = [
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.None,
        value: 1,
        onClick: this.handleParametersClick,
      },
      {
        label: APPDATA.ENUM.RECOVERY_OF_LIQUID.Air,
        value: 2,
        onClick: this.handleParametersClick,
      },
    ];
    return {
      label,
      buttonProp: availableBuffer ? recoveryOfLiquidComplete : recoveryOfLiquidWithoutBuffer,
      defaultValue: defaultRecoveryOfLiquid,
      value: defaultRecoveryOfLiquid,
      onClick,
    };
  };

  handleAdvSetupClick = () => {
    const {dispatch} = this.props;

    dispatch(openAdvSetup());
  };

  handleParametersClick = (e) => {
    const {
      startingVolume,
      volumeToStartAt,
      bufferVolumeToUse,
      totalBufferVolumeToUse,
      finalVolume,
      startingConcentration,
      stepSizeVolume,
      conicalVolume,
      autoProfileSetupMode,
      dispatch,
    } = this.props;
    const {configParam} = this.state;

    let value;
    let unit;
    let info;
    let maxValue = AutoProfileConstants.MAX_VALUE;
    let minValue = AutoProfileConstants.MIN_VALUE;
    let maxDigitAfterDecimal = APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY;
    let incrementValue = APPDATA.CONFIGURATION.VOLUME_SENSOR.INCREMENT_VALUE;
    const tube1 = parseFloat(configParam[autoProfileSetupMode].startVolume01);
    const tube2 = parseFloat(configParam[autoProfileSetupMode].startVolume02);
    switch (e.currentTarget.id) {
      case APPDATA.FIELD_NAME.STARTING_VOLUME: {
        value = configParam[autoProfileSetupMode].startVolume;
        unit = APPDATA.UNIT.ml;

        switch (autoProfileSetupMode) {
          case AutoProfileSetupMode[0]: {
            const {max, min} = getLimitStartVolConc(conicalVolume);

            maxValue = max;
            minValue = min;
            break;
          }
          default: {
            const {max, min} = getLimitStartVol(conicalVolume);

            maxValue = max;
            minValue = min;
            break;
          }
        }

        break;
      }
      case APPDATA.FIELD_NAME.STARTING_CONCENTRATION: {
        const {max, min} = getLimitStartConcentration();

        maxValue = max;
        minValue = min;
        value = configParam[autoProfileSetupMode].startConcentration;
        maxDigitAfterDecimal = APPDATA.CONFIGURATION.CONCENTRATE_SENSOR.DECIMAL_PLACE_ACCURACY;
        unit = APPDATA.UNIT.mg_per_ml;
        break;
      }
      case APPDATA.FIELD_NAME.FINAL_VOLUME: {
        value = configParam[autoProfileSetupMode].finalVolume;
        unit = APPDATA.UNIT.ml;
        // info = APPDATA.MESSAGES.PROFILE.NUMPAD[APPDATA.FIELD_NAME.FINAL_VOLUME].INFO;

        switch (autoProfileSetupMode) {
          case AutoProfileSetupMode[0]: {
            const {max, min} = getLimitFinalVolConc(startingVolume, conicalVolume);

            maxValue = max;
            minValue = min;
            break;
          }
          case AutoProfileSetupMode[1]: {
            const {max, min} = getLimitFinalVolConc2Tubes(tube1, tube2, conicalVolume);

            maxValue = max;
            minValue = min;
            break;
          }
          case AutoProfileSetupMode[2]: {
            const {max, min} = getLimitFinalVolBufferExchange(startingVolume, conicalVolume);
            maxValue = max;
            minValue = min;
            break;
          }
          default:
            break;
        }

        break;
      }
      case APPDATA.FIELD_NAME.FINAL_CONCENTRATION: {
        value = configParam[autoProfileSetupMode].finalConcentration;
        unit = APPDATA.UNIT.mg_per_ml;
        // info = APPDATA.MESSAGES.PROFILE.NUMPAD[APPDATA.FIELD_NAME.FINAL_CONCENTRATION].INFO;

        if (startingConcentration < 1) {
          maxDigitAfterDecimal = APPDATA.CONFIGURATION.CONCENTRATE_SENSOR.DECIMAL_PLACE_ACCURACY;
        } else maxDigitAfterDecimal = APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY;

        switch (autoProfileSetupMode) {
          case AutoProfileSetupMode[0]: {
            const {max, min} = getLimitFinalConcentrationConc(startingVolume, startingConcentration);

            maxValue = max;
            minValue = min;
            break;
          }
          case AutoProfileSetupMode[1]: {
            const {max, min} = getLimitFinalConcentrationConc2Tubes(tube1, tube2, startingConcentration, conicalVolume);

            maxValue = max;
            minValue = min;
            break;
          }
          case AutoProfileSetupMode[2]: {
            const {max, min} = getLimitFinalConcentrationBufferExchange(
              startingVolume,
              startingConcentration,
              conicalVolume,
            );
            maxValue = max;
            minValue = min;
            break;
          }
          default:
            break;
        }

        break;
      }
      case APPDATA.FIELD_NAME.STARTING_VOLUME_FIRST_TUBE: {
        const {max, min} = getLimitStartingVol1stTubeConc2Tubes(conicalVolume);

        value = configParam[autoProfileSetupMode].startVolume01;
        maxValue = max;
        minValue = min;
        unit = APPDATA.UNIT.ml;
        break;
      }
      case APPDATA.FIELD_NAME.STARTING_VOLUME_SECOND_TUBE: {
        const {max, min} = getLimitStartingVol2ndTubeConc2Tubes();

        value = configParam[autoProfileSetupMode].startVolume02;
        maxValue = max;
        minValue = min;
        unit = APPDATA.UNIT.ml;
        break;
      }
      case APPDATA.FIELD_NAME.VOLUME_TO_START_AT: {
        const {max, min} = getLimitVolToStartAtBufferExchange(startingVolume, finalVolume, conicalVolume);

        value = volumeToStartAt;
        unit = APPDATA.UNIT.ml;
        maxValue = max;
        minValue = min;
        break;
      }
      case APPDATA.FIELD_NAME.EXCHANGE_VOLUME: {
        const {max, min} = getLimitBufferVolToUseBufferExchange();

        value = bufferVolumeToUse;
        unit = APPDATA.UNIT.ml;
        minValue = min;
        maxValue = max;
        break;
      }
      case APPDATA.FIELD_NAME.EXCHANGE_SIZE: {
        const {max, min} = getLimitStepSizeBufferExchange(bufferVolumeToUse, volumeToStartAt, conicalVolume);

        value = stepSizeVolume;
        unit = APPDATA.UNIT.ml;
        minValue = min;
        maxValue = max;
        maxDigitAfterDecimal = 1;
        incrementValue = 1;
        break;
      }
      case APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME:
      case APPDATA.FIELD_NAME.ESTIMATED_CURRENT_BUFFER_VOLUME: {
        const {max, min} = getLimitTotalBufferVolToUseBufferExchange();

        value = totalBufferVolumeToUse;
        unit = APPDATA.UNIT.ml;
        maxValue = max;
        minValue = min;
        break;
      }
      default:
        break;
    }

    if (PC_COMMON_FUNCTION.isEmptyFieldValue(value)) value = '0';

    if (value !== undefined) {
      dispatch(
        modalActions.showModal({
          modalHeader: e.currentTarget.id,
          value,
          callback: this.handleParametersChange,
          maxValue,
          minValue,
          maxDigitAfterDecimal,
          incrementValue,
          unit,
          info,
        }),
      );
    }
  };

  handleParametersChange = (e) => {
    const {autoProfileSetupMode, dispatch} = this.props;
    const {configParam} = this.state;
    const newConfigParam = {...configParam};

    switch (autoProfileSetupMode) {
      case AutoProfileSetupMode[0]: {
        const concentrateParams = dispatch(changeConcentrateParam(e.type, e.value));

        this.setState({
          configParam: {
            ...newConfigParam,
            [autoProfileSetupMode]: {
              ...newConfigParam[autoProfileSetupMode],
              ...concentrateParams,
            },
          },
        });
        return;
      }
      case AutoProfileSetupMode[1]: {
        const concentrateParams = dispatch(changeConcentrate2TubesParam(e.type, e.value));

        this.setState({
          configParam: {
            ...newConfigParam,
            [autoProfileSetupMode]: {
              ...newConfigParam[autoProfileSetupMode],
              ...concentrateParams,
            },
          },
        });
        return;
      }
      case AutoProfileSetupMode[2]: {
        const concentrateParams = dispatch(changeBufferExchangeParam(e.type, e.value));

        this.setState({
          configParam: {
            ...newConfigParam,
            [autoProfileSetupMode]: {
              ...newConfigParam[autoProfileSetupMode],
              ...concentrateParams,
            },
          },
        });
        break;
      }

      default:
        break;
    }
  };

  onClickCalculator = (e) => {
    const {startingVolume, volumeToStartAt, finalVolume, stepSizeVolume, bufferVolumeToUse, dispatch, conicalVolume} =
      this.props;
    const {calculator} = this.state;

    let value;
    let unit;
    const info = undefined;
    let maxValue = AutoProfileConstants.MAX_VALUE;
    let minValue = AutoProfileConstants.MIN_VALUE;
    let maxDigitAfterDecimal = APPDATA.CONFIGURATION.VOLUME_SENSOR.DECIMAL_PLACE_ACCURACY;
    let incrementValue = APPDATA.CONFIGURATION.VOLUME_SENSOR.INCREMENT_VALUE;
    const newCalculator = {...calculator};
    switch (e.currentTarget.id) {
      case APPDATA.FIELD_NAME.DIAFILTRATION_CALCULATOR:
        newCalculator.volumeToStartAt = volumeToStartAt;
        newCalculator.percentage = APPDATA.EMPTY_FIELD;
        newCalculator.stepSize = PC_COMMON_FUNCTION.isEmptyFieldValue(stepSizeVolume)
          ? calculator.stepSize
          : Number(stepSizeVolume);
        newCalculator.bufferNeeded = APPDATA.EMPTY_FIELD;
        newCalculator.exchangeStepSize = APPDATA.EMPTY_FIELD;
        newCalculator.stepSizeVolume = APPDATA.EMPTY_FIELD;
        newCalculator.showWarning = false;
        this.setState(
          {
            calculator: newCalculator,
          },
          () => {
            this.showDiafiltrationCalculator();
          },
        );
        return;

      case APPDATA.FIELD_NAME.VOLUME_TO_START_AT: {
        const {max, min} = getLimitVolToStartAtBufferExchange(startingVolume, finalVolume, conicalVolume);
        dispatch(modalActions.hidePopUp());
        value = calculator.volumeToStartAt;
        unit = APPDATA.UNIT.ml;
        maxValue = max;
        minValue = min;

        break;
      }

      case APPDATA.FIELD_NAME.EXCHANGE_PERCENTAGE:
        dispatch(modalActions.hidePopUp());
        value = calculator.percentage;
        unit = APPDATA.UNIT.percentage;
        maxValue = 99;
        minValue = 10;
        maxDigitAfterDecimal = 0;
        incrementValue = 1;
        break;
      case APPDATA.FIELD_NAME.STEP_SIZE:
        dispatch(modalActions.hidePopUp());
        value = calculator.stepSize;
        unit = APPDATA.UNIT.ml;
        minValue = 0.1;
        maxValue = calcMaxStepSizeCalculator(Math.ceil(parseFloat(bufferVolumeToUse)), newCalculator.volumeToStartAt);
        maxDigitAfterDecimal = 1;
        incrementValue = 1;
        break;
      case APPDATA.APPLY:
        if (
          !PC_COMMON_FUNCTION.isEmptyFieldValue(newCalculator.bufferNeeded) &&
          (newCalculator.bufferNeeded < 1 || newCalculator.bufferNeeded > 300)
        ) {
          newCalculator.showWarning = true;
          this.setState(
            {
              calculator: newCalculator,
            },
            () => {
              this.showDiafiltrationCalculator();
            },
          );
        } else {
          dispatch(
            applyDiafiltrationCalculator(
              newCalculator.volumeToStartAt,
              newCalculator.bufferNeeded,
              calculator.stepSize,
            ),
          );
        }
        return;

      case APPDATA.CANCEL:
        newCalculator.showWarning = false;
        dispatch(modalActions.hidePopUp());
        return;
      default:
        break;
    }

    if (PC_COMMON_FUNCTION.isEmptyFieldValue(value)) value = '0';

    if (value !== undefined) {
      dispatch(
        modalActions.showModal({
          modalHeader: e.currentTarget.id,
          value,
          callback: this.onChangeCalculator,
          maxValue,
          minValue,
          maxDigitAfterDecimal,
          incrementValue,
          unit,
          info,
        }),
      );
    }
  };

  onChangeCalculator = (e) => {
    const {calculator} = this.state;
    const newCalculator = {...calculator};

    if (e.type) {
      switch (e.type) {
        case APPDATA.FIELD_NAME.VOLUME_TO_START_AT:
          newCalculator.volumeToStartAt = e.value;
          break;
        case APPDATA.FIELD_NAME.EXCHANGE_PERCENTAGE:
          newCalculator.percentage = e.value;
          break;
        case APPDATA.FIELD_NAME.STEP_SIZE:
          newCalculator.stepSize = e.value;
          break;
        default:
          break;
      }

      newCalculator.stepSizeVolume = newCalculator.stepSize;
      newCalculator.bufferNeeded = calcBufferNeededCalculator(
        newCalculator.volumeToStartAt,
        newCalculator.percentage,
        newCalculator.stepSize,
      );

      this.setState(
        {
          calculator: newCalculator,
        },
        () => {
          this.showDiafiltrationCalculator();
        },
      );
    }
  };

  // FIXME: move this event handler to business action
  handleChangeMethodButton = (value) => {
    const {dispatch} = this.props;
    if (value) {
      const newConfigParam = dispatch(changeMethodAutoProfile(value));
      this.setState({
        configParam: newConfigParam,
      });
    }
  };

  handleMembraneTypeChange = (selected) => {
    const {dispatch} = this.props;

    if (selected !== null) {
      dispatch(updateProfileParamByName(APPDATA.KEY.MembraneType, String(selected)));
      dispatch(resetMWCO());
    }
  };

  handleMembraneCutOffChange = (selected) => {
    const {dispatch} = this.props;

    dispatch(updateProfileParamByName(APPDATA.KEY.MembraneCutOffSize, selected.value));
  };

  handleConicalChange = (selected) => {
    const {dispatch} = this.props;

    dispatch(changeConical(selected.value));
  };

  handleResetClick = () => {
    const {dispatch} = this.props;

    const newConfigParam = dispatch(resetAutoProfileParams());
    this.setState({
      configParam: newConfigParam,
    });
  };

  disabledFvFc = () => {
    const {
      isPCRunning,
      conicalVolume,
      moreThan50ml,
      startingVolumeFor2ndTube,
      startingConcentration,
      autoProfileSetupMode,
    } = this.props;
    const {configParam} = this.state;

    return !!(
      (moreThan50ml === APPDATA.ENUM.MORE_THAN_50_ML.ON &&
        PC_COMMON_FUNCTION.isEmptyFieldValue(startingVolumeFor2ndTube)) ||
      (conicalVolume === ConicalType[50].toString() &&
        PC_COMMON_FUNCTION.isEmptyFieldValue(configParam[autoProfileSetupMode].startVolume)) ||
      (conicalVolume === ConicalType[15].toString() &&
        PC_COMMON_FUNCTION.isEmptyFieldValue(configParam[autoProfileSetupMode].startVolume01)) ||
      PC_COMMON_FUNCTION.isEmptyFieldValue(startingConcentration) ||
      isPCRunning
    );
  };

  renderToggleMethod(id, label, onClick, disable) {
    const ToggleData =
      label === APPDATA.FIELD_NAME.RECOVERY_OF_LIQUID
        ? this.getDataRecoveryOfLiquid(label, onClick)
        : this.getDataSkipPriming(onClick);

    return (
      <ToggleButton
        label={ToggleData.label}
        buttonProp={ToggleData.buttonProp}
        defaultValue={ToggleData.defaultRecoveryOfLiquid}
        value={ToggleData.value}
        onClick={ToggleData.onClick}
        disabled={disable}
      />
    );
  }

  renderInputField(id, label, input, unit, onClick, hideField, disable) {
    const {invalidAutoProfileParams, dispatch} = this.props;

    let showWarning;
    if (label === APPDATA.FIELD_NAME.FINAL_VOLUME) {
      showWarning = invalidAutoProfileParams?.includes(label);
    } else if (label === APPDATA.FIELD_NAME.STARTING_VOLUME_FIRST_TUBE) {
      showWarning =
        invalidAutoProfileParams &&
        invalidAutoProfileParams.length > 0 &&
        invalidAutoProfileParams?.includes(APPDATA.FIELD_NAME.STARTING_VOLUME);
    } else if (label === APPDATA.FIELD_NAME.ESTIMATED_CURRENT_BUFFER_VOLUME) {
      showWarning =
        invalidAutoProfileParams &&
        invalidAutoProfileParams.length > 0 &&
        invalidAutoProfileParams?.includes(APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME);
    } else {
      showWarning =
        invalidAutoProfileParams && invalidAutoProfileParams.length > 0 && invalidAutoProfileParams?.includes(label);
    }

    const value = PC_COMMON_FUNCTION.isEmptyFieldValue(input) || input === 0 ? APPDATA.EMPTY_FIELD : input;

    return (
      <div style={{display: 'flex', alignItems: 'center', position: 'relative'}}>
        <InputField
          id={id}
          label={label}
          inputValue={value}
          unit={unit}
          onClick={onClick}
          hideField={hideField}
          disabled={disable}
        />
        {showWarning && (
          <IconExclamation
            id={id}
            onClick={(e) => dispatch(handleWarningInvalidParamClick(e.currentTarget.id))}
          />
        )}
      </div>
    );
  }

  renderSelectField = (id, label, onClick, option, value, unit, onChange) => {
    const {isPCRunning} = this.props;
    const styleCustom = {width: '150px'};

    return (
      <SelectField
        label={label}
        value={value}
        unit={unit}
        options={option}
        onChange={(selected) => {
          const e = {
            type: label,
            value: selected.value,
          };
          onChange(e);
        }}
        styleCustom={styleCustom}
        disabled={isPCRunning}
      />
    );
  };

  // eslint-disable-next-line class-methods-use-this
  renderButton(id, classNameButton, label, onClick, icon, classNameIcon, disableButton) {
    return (
      <Button
        id={id}
        onClick={onClick}
        className={classNameButton}
        label={label}
        icon={icon}
        iconClassName={classNameIcon}
        disabled={disableButton === undefined ? false : disableButton}
      />
    );
  }

  renderRowField(
    col1,
    disable1,
    id1,
    label1,
    inputValue1,
    unit1,
    hideField1,
    option1,
    onChange1,
    onClick,
    col2,
    disable2,
    id2,
    label2,
    inputValue2,
    unit2,
    hideField2,
    option2,
    onChange2,
    styleCustom,
    col3,
    classNameButton,
    disableButton,
    idButton,
    labelButton,
    onClickButton,
    iconButton,
    classNameIconButton,
  ) {
    const classLabel2 = col2 === BUTTON ? `${APPSTYLE.COLUMN_5} margin-button` : APPSTYLE.COLUMN_5;

    return (
      <div className={`row rowHeightAutoProfile middleAlign ${styleCustom}`}>
        {col1 !== SELECT && (
          <div className={APPSTYLE.COLUMN_5}>
            {col1 === INPUT && this.renderInputField(id1, label1, inputValue1, unit1, onClick, hideField1, disable1)}
            {col1 === TOGGLE && this.renderToggleMethod(id1, label1, onClick, disable1)}
          </div>
        )}
        {col1 === SELECT && (
          <div className={APPSTYLE.COLUMN_5}>
            {this.renderSelectField(id1, label1, onClick, option1, inputValue1, unit1, onChange1)}
          </div>
        )}
        {label2 !== undefined && (
          <div className={classLabel2}>
            {col2 === INPUT && this.renderInputField(id2, label2, inputValue2, unit2, onClick, hideField2, disable2)}
            {col2 === TOGGLE && this.renderToggleMethod(id2, label2, onClick, disable2)}
            {col2 === SELECT && this.renderSelectField(id2, label2, onClick, option2, inputValue2, unit2, onChange2)}
            {col2 === BUTTON && this.renderButton(id2, label2, label2, onClick)}
          </div>
        )}
        {col3 !== undefined && (
          <div
            className={APPSTYLE.COLUMN_UNIT}
            style={{textAlign: 'left', left: '10px'}}
          >
            {this.renderButton(
              idButton,
              classNameButton,
              labelButton,
              onClickButton,
              iconButton,
              classNameIconButton,
              disableButton,
            )}
          </div>
        )}
      </div>
    );
  }

  renderConcentrateParams = () => {
    const {
      isPCRunning,
      autoProfileSetupMode,
      profileRunningConfigStartingVolume,
      profileRunningConfigStartingConcentration,
      profileRunningConfigFinalVolume,
      profileRunningConfigEstimatedFinalConcentration,
      isScheduleWillRun,
      isSetScheduleRun,
    } = this.props;
    const {configParam} = this.state;

    const disableFvFc = this.disabledFvFc();

    return (
      <>
        {this.renderRowField(
          INPUT,
          isPCRunning || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.STARTING_VOLUME,
          APPDATA.FIELD_NAME.STARTING_VOLUME,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].startVolume)
            : Number(profileRunningConfigStartingVolume),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          this.handleParametersClick,
          INPUT,
          isPCRunning || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.STARTING_CONCENTRATION,
          APPDATA.FIELD_NAME.STARTING_CONCENTRATION,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].startConcentration)
            : Number(profileRunningConfigStartingConcentration),
          APPDATA.UNIT.mg_per_ml,
          undefined,
          undefined,
          undefined,
          undefined,
        )}

        {this.renderRowField(
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.FINAL_VOLUME,
          APPDATA.FIELD_NAME.FINAL_VOLUME,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].finalVolume)
            : Number(profileRunningConfigFinalVolume),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          this.handleParametersClick,
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.FINAL_CONCENTRATION,
          APPDATA.FIELD_NAME.FINAL_CONCENTRATION,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].finalConcentration)
            : Number(profileRunningConfigEstimatedFinalConcentration),
          APPDATA.UNIT.mg_per_ml,
          undefined,
          undefined,
          undefined,
          undefined,
        )}
      </>
    );
  };

  renderConcentrate2TubesParams = () => {
    const {
      isPCRunning,
      autoProfileSetupMode,
      profileRunningConfigStartingVolume,
      profileRunningConfigStartingVolumeFor2ndTube,
      profileRunningConfigStartingConcentration,
      profileRunningConfigFinalVolume,
      profileRunningConfigEstimatedFinalConcentration,
      isScheduleWillRun,
      isSetScheduleRun,
    } = this.props;
    const {configParam} = this.state;

    const disableFvFc = this.disabledFvFc();

    return (
      <>
        {this.renderRowField(
          INPUT,
          isPCRunning || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.STARTING_VOLUME_FIRST_TUBE,
          APPDATA.FIELD_NAME.STARTING_VOLUME_FIRST_TUBE,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].startVolume01)
            : Number(profileRunningConfigStartingVolume),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          this.handleParametersClick,
          INPUT,
          isPCRunning || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.STARTING_CONCENTRATION,
          APPDATA.FIELD_NAME.STARTING_CONCENTRATION,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].startConcentration)
            : Number(profileRunningConfigStartingConcentration),
          APPDATA.UNIT.mg_per_ml,
          undefined,
          undefined,
          undefined,
          undefined,
        )}
        {this.renderRowField(
          INPUT,
          isPCRunning || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.STARTING_VOLUME_SECOND_TUBE,
          APPDATA.FIELD_NAME.STARTING_VOLUME_SECOND_TUBE,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].startVolume02)
            : Number(profileRunningConfigStartingVolumeFor2ndTube),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          this.handleParametersClick,
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.FINAL_CONCENTRATION,
          APPDATA.FIELD_NAME.FINAL_CONCENTRATION,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].finalConcentration)
            : Number(profileRunningConfigEstimatedFinalConcentration),
          APPDATA.UNIT.mg_per_ml,
          undefined,
          undefined,
          undefined,
          undefined,
        )}
        {this.renderRowField(
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.FINAL_VOLUME,
          APPDATA.FIELD_NAME.FINAL_VOLUME,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].finalVolume)
            : Number(profileRunningConfigFinalVolume),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          this.handleParametersClick,
          INPUT,
          isPCRunning || isScheduleWillRun || isSetScheduleRun,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        )}
      </>
    );
  };

  renderBufferExchangeParams = () => {
    const {
      isPCRunning,
      volumeToStartAt,
      bufferVolumeToUse,
      totalBufferVolumeToUse,
      exchangeStepSize,
      autoProfileSetupMode,
      profileRunningConfigStartingVolume,
      profileRunningConfigStartingConcentration,
      profileRunningConfigFinalVolume,
      profileRunningConfigEstimatedFinalConcentration,
      profileRunningConfigVolumeToStartAt,
      profileRunningConfigBufferVolumeToUse,
      profileRunningConfigExchangeStepSize,
      profileRunningConfigTotalBufferVolumeToUse,
      isScheduleWillRun,
      isSetScheduleRun,
      highVolumeBufferFlag,
    } = this.props;
    const {configParam} = this.state;

    const disableFvFc = this.disabledFvFc();

    return (
      <>
        {this.renderRowField(
          INPUT,
          isPCRunning || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.STARTING_VOLUME,
          APPDATA.FIELD_NAME.STARTING_VOLUME,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].startVolume)
            : Number(profileRunningConfigStartingVolume),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          this.handleParametersClick,
          INPUT,
          isPCRunning || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.STARTING_CONCENTRATION,
          APPDATA.FIELD_NAME.STARTING_CONCENTRATION,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].startConcentration)
            : Number(profileRunningConfigStartingConcentration),
          APPDATA.UNIT.mg_per_ml,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        )}
        {this.renderRowField(
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.FINAL_VOLUME,
          APPDATA.FIELD_NAME.FINAL_VOLUME,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].finalVolume)
            : Number(profileRunningConfigFinalVolume),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          this.handleParametersClick,
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.FINAL_CONCENTRATION,
          APPDATA.FIELD_NAME.FINAL_CONCENTRATION,
          !isPCRunning
            ? Number(configParam[autoProfileSetupMode].finalConcentration)
            : Number(profileRunningConfigEstimatedFinalConcentration),
          APPDATA.UNIT.mg_per_ml,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
        )}
        {this.renderRowField(
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.VOLUME_TO_START_AT,
          APPDATA.FIELD_NAME.VOLUME_TO_START_AT,
          !isPCRunning ? Number(volumeToStartAt) : Number(profileRunningConfigVolumeToStartAt),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          this.handleParametersClick,
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.EXCHANGE_VOLUME,
          APPDATA.FIELD_NAME.EXCHANGE_VOLUME,
          !isPCRunning ? Number(bufferVolumeToUse) : Number(profileRunningConfigBufferVolumeToUse),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          'rowBufferExchange',
          BUTTON,
          APPDATA.FIELD_NAME.DIAFILTRATION_CALCULATOR,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          APPDATA.FIELD_NAME.DIAFILTRATION_CALCULATOR,
          undefined,
          this.onClickCalculator,
          ExchangeCalculator,
          'diafiltrationCalculatorButtonIcon',
        )}
        {this.renderRowField(
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.EXCHANGE_SIZE,
          APPDATA.FIELD_NAME.EXCHANGE_SIZE,
          !isPCRunning
            ? Number(exchangeStepSize)
            : Number(
                profileRunningConfigExchangeStepSize === undefined
                  ? exchangeStepSize
                  : profileRunningConfigExchangeStepSize,
              ),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          this.handleParametersClick,
          INPUT,
          disableFvFc || isScheduleWillRun || isSetScheduleRun,
          autoProfileSetupMode + APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME,
          !highVolumeBufferFlag
            ? APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME
            : APPDATA.FIELD_NAME.ESTIMATED_CURRENT_BUFFER_VOLUME,
          !isPCRunning ? Number(totalBufferVolumeToUse) : Number(profileRunningConfigTotalBufferVolumeToUse),
          APPDATA.UNIT.ml,
          undefined,
          undefined,
          undefined,
          'rowBufferExchange',
        )}
      </>
    );
  };

  render() {
    const {
      fontSize,
      isPCRunning,
      deviceVersion,
      currentAdvSetupParamsName,
      membraneCutOffSize,
      membraneType,
      conicalVolume,
      autoProfileSetupMode,
      profileRunningConfigAdvancedSetupName,
      profileRunningConfigMoreThan50ml,
      profileRunningConfigDiafiltrationMode,
      profileRunningConfigMembraneCutOffSize,
      profileRunningConfigConicalVolume,
      isScheduleWillRun,
      isSetScheduleRun,
      advSetupSetupName,
    } = this.props;

    let AdvSetupUsed = 'DEFAULT SETUP';

    if (isPCRunning && !PC_COMMON_FUNCTION.isEmptyFieldValue(profileRunningConfigAdvancedSetupName)) {
      // development mode
      AdvSetupUsed = profileRunningConfigAdvancedSetupName;
    }

    if (currentAdvSetupParamsName) {
      AdvSetupUsed = !isSetScheduleRun ? currentAdvSetupParamsName : advSetupSetupName;
    }

    const style = {
      constraint: {
        fontSize: fontSize === APPDATA.LARGE_FONT_SIZE ? APPDATA.MEDIUM_FONT_SIZE : fontSize,
      },
    };

    let runningMode = AutoProfileSetupMode[0];
    if (isPCRunning) {
      if (String(profileRunningConfigMoreThan50ml) === APPDATA.ENUM.MORE_THAN_50_ML.ON) {
        // eslint-disable-next-line prefer-destructuring
        runningMode = AutoProfileSetupMode[1];
      } else if (String(profileRunningConfigDiafiltrationMode) !== APPDATA.FIELD_NAME.DIAFILTRATION_OPTION.NONE) {
        // eslint-disable-next-line prefer-destructuring
        runningMode = AutoProfileSetupMode[2];
      }
    }

    const selectedMethod = !isPCRunning ? autoProfileSetupMode : runningMode;

    const methodButtonItems = AutoProfileSetupModes.map((e) => ({
      id: e.value,
      text: e.value,
      disabled: (isPCRunning && e.value !== autoProfileSetupMode) || isScheduleWillRun || isSetScheduleRun,
    }));

    const membraneCutOffValue = MembraneCutOff[profileRunningConfigMembraneCutOffSize] || MembraneCutOff.CHIP_3_KDA;

    const conicalValue =
      !isPCRunning || !Object.prototype.hasOwnProperty.call(ConicalType, profileRunningConfigConicalVolume)
        ? conicalVolume
        : ConicalType[Number(profileRunningConfigConicalVolume || ConicalType[50])].toString();

    return (
      <div
        style={style.constraint}
        className="auto-profile-content"
      >
        <div className="rowHeightAutoProfile toggleButtonMenuAutoProfileSetup">
          <div className="toggleProfileType">
            <FmlxToggleButton
              items={methodButtonItems}
              value={selectedMethod}
              onChange={this.handleChangeMethodButton}
            />
          </div>
          <div style={{marginRight: '16px'}}>
            <button
              type="button"
              className="ResetButton enabled"
              onClick={this.handleResetClick}
              disabled={isPCRunning || isScheduleWillRun || isSetScheduleRun}
            >
              {APPDATA.RESET.toUpperCase()}
            </button>
          </div>
        </div>
        <div className="auto-profile-form-params">
          {autoProfileSetupMode === AutoProfileSetupMode[0] && this.renderConcentrateParams()}
          {autoProfileSetupMode === AutoProfileSetupMode[1] && this.renderConcentrate2TubesParams()}
          {autoProfileSetupMode === AutoProfileSetupMode[2] && this.renderBufferExchangeParams()}
        </div>

        <div className="bottomAutoSetup">
          <hr className="row-setup-autoprofile" />
          <div className="bottomAutoSetupMenu">
            {deviceVersion !== VERSION_2 && (
              <SelectionDropdowns
                value={conicalValue}
                disabled={isPCRunning || isScheduleWillRun || isSetScheduleRun}
                onChange={this.handleConicalChange}
                name={LEFT_CONICAL}
                unit={APPDATA.UNIT.ml}
                version={deviceVersion}
                options={deviceVersion === VERSION_2 ? ConicalOptionsV2 : ConicalOptionsV3}
                id="conical"
              />
            )}
            <MembraneType
              value={membraneTypeConverter(membraneType)}
              onChange={this.handleMembraneTypeChange}
              name="MWCO"
              id="membrane-type"
              disabled={isPCRunning || isScheduleWillRun || isSetScheduleRun}
            />
            <SelectionDropdowns
              value={!isPCRunning ? membraneCutOffSize : membraneCutOffValue}
              disabled={isPCRunning || isScheduleWillRun || membraneType === undefined || isSetScheduleRun}
              onChange={this.handleMembraneCutOffChange}
              name=""
              unit={APPDATA.UNIT.kda}
              options={
                membraneTypeConverter(membraneType) === MembraneTypeOptions.MPES
                  ? MembraneCutOffOptions
                  : MembraneCutOffRCOptions
              }
              id={APPDATA.FIELD_NAME.MEMBRANE_CUT_OFF_SIZE}
            />
            <div className="advancedSetupSelection">
              <div className="labelStyle3">{APPDATA.FIELD_NAME.ADVANCED_SETUP}</div>
              <button
                className="advancedSetupButton center"
                onClick={this.handleAdvSetupClick}
                disabled={isPCRunning || isScheduleWillRun || isSetScheduleRun}
                type="button"
              >
                <div style={{width: '100%', justifyContent: 'center', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                  {AdvSetupUsed}
                </div>
                &nbsp;
                <img
                  src={More}
                  alt={More}
                />
              </button>
            </div>
          </div>
        </div>
        <AutoProfileTopMenu
          activeTopMenu={APPDATA.AUTO_PROFILE_SETUP_TAB}
          titleTopMenu={APPDATA.AUTO_PROFILE.toUpperCase()}
        />
        <AutoProfilePageMenu />
      </div>
    );
  }
}
export default AutoProfileSetup;
